import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

export const renderWhatsNewDialog = renderModalDialog(WhatsNewDialog, 'WhatsNewDialog');
